<template>
  <div class="cmp-contacts-groups-group_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="dt-page--add-button">
        <div class="dt-icon-container">
          <img
            @click="onAddContactClick"
            class="dt-icon v5 s1"
            src="static/buttons/add.svg"
            alt
          />
        </div>
      </div>
    </div>

    <div class="dt-page--body">
      <NTable
        id="contacts-groups-group_list"
        class="h1"
        :config="tableConfig"
        :headers="contactGroupHeaders"
        :items="contactGroups"
        :loadingFlag="loadingFlag"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr
            @click="onContactGroupClicked(item)"
            :title="'Click to see Contact Details'"
          >
            <td style="cursor: pointer" v-bind="tdcon('group')">
              <span>{{ item["group_name"] }}</span>
            </td>
            <td v-bind="tdcon('comment')">
              <span>{{ item["comment"] }}</span>
            </td>
            <td v-bind="tdcon('no_of_member')">
              <span>{{ item["member_count"] }}</span>
            </td>
            <td v-bind="tdcon('options')">
              <img
                src="static/icons/delete.svg"
                @click.stop="(e) => deleteContactGroup(item)"
                class="dt-icon v5 s2"
                alt
              />
            </td>
          </tr>
        </template>
      </NTable>
    </div>

    <Sidewindow
      :value="contactGroupDetailsFlag"
      @closed="onCloseGroupSidewindow"
    >
      <GroupSidewindow
        :selectedContactGroup="selectedContactGroup"
        @closeGroupSidewindow="onCloseGroupSidewindow"
        @deleteGroup="deleteContactGroup"
      ></GroupSidewindow>
    </Sidewindow>
  </div>
</template>

<script>
import { ContactStoreNamespace as storeNS } from "../../store";
import { mapGetters, mapActions } from "vuex";
import * as ActionTypes from "../../store/types";
import {
  contactGroupsListLDTRoutes,
  getContactGroupDetailsSelectable,
} from "../../router/routes";
import {
  onDetailsRowClicked,
  childOfOrEqualDetails,
} from "../../../../utility/route";
import { SelectResults } from "../../../booking/router/router";
import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";
import GroupSidewindow from "./sidewindow";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import NTable from "@/plugins/datatable/datatable";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import InputField from "@plugins/text-field/input-field";
import { ConfirmationService } from "@/dt-plugins/confirmation/confirmation.service";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { async } from "ramda-adjunct";
import { confirmDelete } from "@/dt-plugins/confirmation/confirmation-common";
const LDTConfig = {
  entityName: "group",
  ldtRoutes: contactGroupsListLDTRoutes,
  detailsSelectableFunction: getContactGroupDetailsSelectable,
  primaryKey: "group_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.ContactGroupDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.ContactGroupDetails.FETCH.SINGLE,
};

export default {
  components: {
    GroupSidewindow,
    NTable,
    InputField,
  },
  mounted: function () {
    this.fetchListReset();
  },
  data: function () {
    return {
      defaultConfig: defaultConfig,
      loadingFlag: false,
      getContactGroupDetailsSelectable: getContactGroupDetailsSelectable,
    };
  },
  mixins: [createLDTHost(LDTConfig)],
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {},
    },
  },
  computed: {
    ...mapGetters(storeNS, {
      contactGroups: "contactGroups",
      selectedContactGroup: "selectedContactGroup",
    }),
    contactGroupDetailsFlag: function () {
      return childOfOrEqualDetails(contactGroupsListLDTRoutes, this.$route);
    },
    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 40,
      });
    },
    list: function () {
      return this.contactGroups;
    },
    contactGroupHeaders: function () {
      return [
        createTableHeader("group", { fw: 700, f: 0.3 }),
        createTableHeader("comment", { f: 0.6 }),
        createTableHeader("no_of_member", { f: 0.2 }),
        createTableHeader("options", {
          text: false,
          mw: 35,
          f: 0.1,
        }),
      ];
    },
  },
  methods: {
    ...mapActions(storeNS, {
      [ActionTypes.ContactGroups.FETCH.ALL]:
        ActionTypes.ContactGroups.FETCH.ALL,
      [ActionTypes.ContactGroups.DELETE.SINGLE]:
        ActionTypes.ContactGroups.DELETE.SINGLE,
    }),
    onContactGroupClicked: function (contact) {
      onDetailsRowClicked(this.$router, contact, contactGroupsListLDTRoutes);
    },
    deleteContactGroup: async function (item) {
      // ConfirmationService.create({
      //   subject: this.$t("delete_group_msg"),
      //   model: true,
      //   width: 500,
      //   completed: (res) => {
      //     switch (res) {
      //       case "OK": {
      //         this[ActionTypes.ContactGroups.DELETE.SINGLE](
      //           item
      //         );
      //         this.$router.push({
      //           name: contactGroupsListLDTRoutes.names.list,
      //         });
      //         break;
      //       }
      //       default: {
      //       }
      //     }
      //   },
      // });
      const confirmationResult = await confirmDelete(
        "Contact",
        item.group_name
      );
      if (confirmationResult === "OK") {
        this[ActionTypes.ContactGroups.DELETE.SINGLE](item);
      }
    },
    onCloseGroupSidewindow: function () {
      this.$router.push({
        name: contactGroupsListLDTRoutes.names.list,
      });
    },
    fetchListReset: async function () {
      this.loadingFlag = true;
      await this[ActionTypes.ContactGroups.FETCH.ALL]();
      this.loadingFlag = false;
    },
    onAddContactClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "contacts_groups_add_new",
        },
      });
    },
  },
};
</script>

<style lang="scss">
.cmp-contacts-groups-group_list {
  .contact-list {
    .dt-table {
      --tb-layout: fixed;

      td.name {
        color: black !important;
        font-weight: 800 !important;
      }
    }
  }
  .dt-page--data-table {
    --offset: 135px;
  }
  .dt-ntable {
    --ntable-height: calc(100vh - 135px);

    td {
      .name-email {
        display: flex;
        height: 100%;

        .name,
        .email {
          overflow: hidden;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .email {
          display: flex;
          justify-content: center;
          text-align: center;
        }

        .name,
        .email {
          flex: 1;
        }
      }
    }
  }
  .artist-top-bar {
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
    width: 100%;

    & > div {
      margin: 0px 10px;
    }

    .add-button {
      flex: 0.4;
      padding: 5px;
      display: flex;
      justify-content: center;
    }
    .search {
      flex: 6;
    }
    .right-space {
      flex: 32;
    }
    @media (min-width: 320px) and (max-width: 480px) {
      .right-space {
        flex: 0;
      }
    }
  }
}
</style>
